var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoDetalle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15372",
    "data-name": "Trazado 15372",
    d: "M40.5-13.5H37.122v-19h0C37-33.244,36.619-33.75,36-33.75H31.5a1.127,1.127,0,0,0-1.125,1.125A1.128,1.128,0,0,0,31.5-31.5h3.372v18H31.5a1.127,1.127,0,0,0-1.125,1.125A1.128,1.128,0,0,0,31.5-11.25h9a1.127,1.127,0,0,0,1.125-1.125A1.128,1.128,0,0,0,40.5-13.5ZM35.986-38.25a2.253,2.253,0,0,0,2.25-2.25,2.253,2.253,0,0,0-2.25-2.25,2.253,2.253,0,0,0-2.25,2.25A2.255,2.255,0,0,0,35.986-38.25ZM36-63A36,36,0,0,0,0-27,36,36,0,0,0,36,9,36,36,0,0,0,72-27,36,36,0,0,0,36-63ZM36,6.75A33.8,33.8,0,0,1,2.25-27,33.8,33.8,0,0,1,36-60.75,33.8,33.8,0,0,1,69.75-27,33.8,33.8,0,0,1,36,6.75Z",
    transform: "translate(0 63)",
    fill: "#fc8403"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDetalle);
export default __webpack_public_path__ + "static/media/info-detalle.0b76335b.svg";
export { ForwardRef as ReactComponent };